import { Typography, TextField, Box } from "@mui/material";
import React from "react";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/Error";
import { makeStyles } from "@mui/styles";

const styles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    gap: "10px",
    marginTop: "10px",
  },
  periodInvalid: {
    display: "flex",
    color: "#ab2525",
    alignItems: "center",
  },
});

const parseUserDateToISO = (value) => {
  // Si la valeur est vide, la retourner telle quelle
  if (!value || value.trim() === "") {
    return value;
  }

  // Si c'est déjà au format ISO 8601, le retourner tel quel
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) {
    return value;
  }

  let day, month, year, hours, minutes;

  // Format: dd.mm.yyyy hh:mm
  const formatDot = /^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})$/;
  // Format: dd/mm/yyyy hh:mm
  const formatSlash = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/;
  // Format: yyyy-mm-dd hh:mm
  const formatDash = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})$/;

  let match;

  if ((match = value.match(formatDot))) {
    [, day, month, year, hours, minutes] = match;
  } else if ((match = value.match(formatSlash))) {
    [, day, month, year, hours, minutes] = match;
  } else if ((match = value.match(formatDash))) {
    [, year, month, day, hours, minutes] = match;
  } else {
    // Format non reconnu, retourner la valeur telle quelle
    return value;
  }

  // Créer un objet Date (en UTC)
  const dateObj = new Date(
    Date.UTC(
      parseInt(year),
      parseInt(month) - 1, // Les mois commencent à 0
      parseInt(day),
      parseInt(hours),
      parseInt(minutes),
      0,
      0
    )
  );

  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    return value; // Retourner la valeur originale si invalide
  }

  // Retourner au format ISO 8601
  return dateObj.toISOString();
};

export default function AdminDatePeriodManager(props) {
  const classes = styles();
  const { label, date, dateId, onEventPlanner } = props;

  const start = new Date(date.start).getTime() / 1000;
  const end = new Date(date.end).getTime() / 1000;
  const isPeriodValid = !isNaN(start) && !isNaN(end) ? end - start > 0 : false;
  const displayPeriodValidityFlag = !isNaN(start) && !isNaN(end);

  const handleChange = (moment) => (event) => {
    const value = event.target.value;
    // Parser et convertir la date au format ISO 8601
    const isoDate = parseUserDateToISO(value);
    onEventPlanner(isoDate, dateId, moment);
  };

  return (
    <React.Fragment>
      <Typography variant="h6">
        {label}{" "}
        {isPeriodValid ? (
          <DoneIcon />
        ) : displayPeriodValidityFlag ? (
          <div className={classes.periodInvalid}>
            <ErrorIcon /> <Typography>Période invalide</Typography>
          </div>
        ) : null}
      </Typography>
      <Box className={classes.root}>
        <Typography>Du</Typography>
        <TextField
          label="Date de début"
          value={date.start || ""}
          onChange={handleChange("start")}
          fullWidth
          placeholder="10.02.2022 20:00 ou 2022-02-10 20:00"
          helperText="Formats acceptés: dd.mm.yyyy hh:mm | dd/mm/yyyy hh:mm | yyyy-mm-dd hh:mm"
        />
      </Box>
      <Box className={classes.root}>
        <Typography>Au</Typography>
        <TextField
          label="Date de fin"
          value={date.end || ""}
          onChange={handleChange("end")}
          fullWidth
          placeholder="10.02.2022 21:30 ou 2022-02-10 21:30"
          helperText="Formats acceptés: dd.mm.yyyy hh:mm | dd/mm/yyyy hh:mm | yyyy-mm-dd hh:mm"
        />
      </Box>
      <br />
    </React.Fragment>
  );
}
